<footer
	class="bg-[#0a0a0f] text-gray-400 border-t border-white/5 relative z-10"
>
	<div class="container mx-auto px-6 max-w-7xl py-16">
		<div class="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
			<!-- Brand -->
			<div class="col-span-1 md:col-span-1">
				<div class="flex items-center gap-2 mb-6">
					<div
						class="w-8 h-8 rounded-xl bg-gradient-to-br from-primary to-neon-cyan flex items-center justify-center text-white font-bold"
					>
						OS
					</div>
					<span class="font-bold text-white text-xl tracking-tight"
						> Studio</span
					>
				</div>
				<p class="text-sm leading-relaxed text-gray-500 mb-6">
					The autonomous operating system builder. From requirements to production infrastructure in minutes.
				</p>
			</div>

			<!-- Product -->
			<div>
				<h4
					class="font-bold text-white mb-6 text-sm uppercase tracking-wider"
				>
					Product
				</h4>
				<ul class="space-y-3">
					<li>
						<a
							href="/pricing"
							class="text-gray-400 hover:text-primary transition-colors duration-200 text-sm"
							>Pricing</a
						>
					</li>
					<li>
						<a
							href="/start"
							class="text-gray-400 hover:text-primary transition-colors duration-200 text-sm"
							>Start Build</a
						>
					</li>
					<li>
						<a
							href="/changelog"
							class="text-gray-400 hover:text-primary transition-colors duration-200 text-sm"
							>Changelog</a
						>
					</li>
				</ul>
			</div>

			<!-- Company -->
			<div>
				<h4
					class="font-bold text-white mb-6 text-sm uppercase tracking-wider"
				>
					Company
				</h4>
				<ul class="space-y-3">
					<li>
						<a
							href="/about"
							class="text-gray-400 hover:text-primary transition-colors duration-200 text-sm"
							>About</a
						>
					</li>
					<li>
						<a
							href="/blog"
							class="text-gray-400 hover:text-primary transition-colors duration-200 text-sm"
							>Blog</a
						>
					</li>
					<li>
						<a
							href="/contact"
							class="text-gray-400 hover:text-primary transition-colors duration-200 text-sm"
							>Contact</a
						>
					</li>
					<li>
						<a
							href="/careers"
							class="text-gray-400 hover:text-primary transition-colors duration-200 text-sm"
							>Careers</a
						>
					</li>
				</ul>
			</div>

			<!-- Legal -->
			<div>
				<h4
					class="font-bold text-white mb-6 text-sm uppercase tracking-wider"
				>
					Legal
				</h4>
				<ul class="space-y-3">
					<li>
						<a
							href="/legal/privacy"
							class="text-gray-400 hover:text-primary transition-colors duration-200 text-sm"
							>Privacy Policy</a
						>
					</li>
					<li>
						<a
							href="/legal/terms"
							class="text-gray-400 hover:text-primary transition-colors duration-200 text-sm"
							>Terms of Service</a
						>
					</li>
					<li>
						<a
							href="/legal/security"
							class="text-gray-400 hover:text-primary transition-colors duration-200 text-sm"
							>Security</a
						>
					</li>
				</ul>
			</div>
		</div>

		<div
			class="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4"
		>
			<p class="text-xs text-gray-600">
				&copy; 2024 OS Studio. All rights reserved.
			</p>
			<div class="flex items-center gap-2 text-xs text-gray-600">
				<span class="w-2 h-2 rounded-full bg-green-500"></span>
				System Operational
			</div>
		</div>
	</div>
</footer>
